export const API_URI_OVERRIDE_STORAGE_KEY = "@mc/mock/api/uri";
export const MOCK_AUTH_STORAGE_KEY = "@mc/mock/auth";
export const MOCK_ACCESS_TOKEN_STORAGE_KEY = "@mc/mock/accessToken";
